import { Route } from "react-router-dom";
import RenewalsActionReport from "../components/ActionReports/RenewalsActionReport/RenewalsActionReport";
import { ROUTE_PATHS } from "../common/enums/routing-enums";
import CbrActionReport from "../components/ActionReports/CbrActionReport/CbrActionReport";
import CvrActionReport from "../components/ActionReports/CvrActionReport/CvrActionReport";
import IboOnboardingActionReport from "../components/ActionReports/IboOnboardingActionReport/IboOnboardingActionReport";
import NbbvActionReport from "../components/ActionReports/NbbvActionReport/NbbvActionReport";
import { withActionReportSelectorRouting } from "../components/ActionReports/utils/ActionReportSelectorRouting";
import WhosNewActionReport from "../components/ActionReports/WhosNewActionReport/WhosNewActionReport";
import { WhosNewActionReportLayout } from "../components/ActionReports/WhosNewActionReport/WhosNewActionReportLayout";
import WhosCloseActionReport from "../components/ActionReports/WhosCloseActionReport/WhosCloseActionReport";
import BirthdaysActionReport from "../components/ActionReports/BirthdaysActionReport/BirthdaysActionReport";
import { ActionReportsTreeView } from "../components/ActionReports/common/ActionReportTreeView/ActionReportsTreeView";
import { RenewalsActionReportRoute } from "../components/ActionReports/RenewalsActionReport/RenewalsActionReportRoute";
import SaqActionReport from "../components/ActionReports/SaqActionReport/SaqActionReport";
import FsiActionReport from "../components/ActionReports/FsiActionReport/FsiActionReport";
import GroupSopReport from "../components/ActionReports/GroupSopReport/GroupSopReport";
export const ACTION_REPORTS_COMPONENT_MAP = {
  [ROUTE_PATHS.IBO_ONBOARDING]: withActionReportSelectorRouting(<IboOnboardingActionReport />),
  [ROUTE_PATHS.CBR]: withActionReportSelectorRouting(<CbrActionReport />),
  [ROUTE_PATHS.CVR]: withActionReportSelectorRouting(<CvrActionReport />),
  [ROUTE_PATHS.BIRTHDAYS_ACTION_REPORT]: withActionReportSelectorRouting(<BirthdaysActionReport />),
  [ROUTE_PATHS.WHOS_CLOSE_ACTION_REPORT]: withActionReportSelectorRouting(<WhosCloseActionReport />),
  [ROUTE_PATHS.NON_BONUSABLE_BV_ACTION_REPORT]: withActionReportSelectorRouting(<NbbvActionReport />),
  [ROUTE_PATHS.SAQ_ACTION_REPORT]: withActionReportSelectorRouting(<SaqActionReport />),
  [ROUTE_PATHS.FSI_ACTION_REPORT]: withActionReportSelectorRouting(<FsiActionReport />),
  [ROUTE_PATHS.SOP_REPORT]: withActionReportSelectorRouting(<GroupSopReport />),
};

export const ActionReportsRoutes = () => {
  return (
    <>
      {Object.entries(ACTION_REPORTS_COMPONENT_MAP).map(([path, element]) => (
        <Route key={path} path={path} element={element} />
      ))}
      <Route
        path={ROUTE_PATHS.WHOS_NEW_ACTION_REPORT}
        element={withActionReportSelectorRouting(<WhosNewActionReportLayout />)}
      >
        <Route index element={<WhosNewActionReport />} />
        <Route path="tree" element={<ActionReportsTreeView />} />
      </Route>
      <Route path={ROUTE_PATHS.RENEWALS} element={withActionReportSelectorRouting(<RenewalsActionReportRoute />)}>
        <Route index element={<RenewalsActionReport />} />
      </Route>
    </>
  );
};
